import { Avatar, AvatarFallback } from '@nesso/ui/primitives/avatar';

import { getEmailInitial } from '../../model/get-email-initial';

type Props = {
    email?: string | null;
};

export function AdminUserDropdownAvatar({ email }: Props) {
    return (
        <Avatar>
            <AvatarFallback className="bg-secondary-background text-secondary-text">
                {getEmailInitial(email)}
            </AvatarFallback>
        </Avatar>
    );
}
